import { detectMediaType } from '@/domain/model/MediaType';

export const extractMediaDuration = (file: File): Promise<number> =>
  new Promise((resolve, reject) => {
    const element = document.createElement(
      detectMediaType(file.type) === 'AUDIO' ? 'audio' : 'video',
    );
    element.preload = 'metadata';
    const url = URL.createObjectURL(file);

    element.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      if (isFinite(element.duration)) {
        resolve(Math.round(element.duration));
      } else {
        reject(new Error('Unable to read media duration'));
      }
    };

    element.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Unable to read media file'));
    };

    element.src = url;
  });
